<cs-header>
  <cs-header-title>{{ LL.helpPage.title() }}</cs-header-title>
</cs-header>

<cs-content>
  <cs-card-list>
    <!-- Search Input -->
    <cs-info-card type="translucent" class="search-input-wrapper" [dismissible]="false">
      <cs-input #searchInput autocomplete="off" id="search-text"
        [(value)]="searchText" type="text" name="searchText" inputmode="search"
        [placeholder]="LL.helpPage.placeholders.searchKnowledgeBase()"
      [iconName]="showSpinner ? 'spinner' : 'search'" (valueChange)="handleSearchChanged()"></cs-input>
    </cs-info-card>

    <!-- Search Results -->
    @if (filteredHelpTexts.length > 0 || (searchText.length > 0 && !showSpinner)) {
      <cs-card>
        <cs-card-content class="faq-content">
          @if (filteredHelpTexts.length > 0) {
            @for (row of filteredHelpTexts; track row.item) {
              <div class="faq-item" tappable (click)="handleHelpTextItemClick(row.item)">
                <div class="faq-item-text">
                  <span class="faq-item-title">{{ row.item.helpText.title }}</span>
                  @if (row.descriptionMarkdown) {
                    <cs-markdown slim class="faq-item-description" [textMarkdown]="row.descriptionMarkdown"></cs-markdown>
                  }
                </div>
                <cs-icon name="arrow-dropright"></cs-icon>
              </div>
            }
          }
          @if (filteredHelpTexts.length === 0 && searchText.length > 0) {
            <div class="empty-state">
              <cs-icon name="search"></cs-icon>
              <div class="empty-state-text">
                <span class="empty-state-title">{{ LL.helpPage.messages.noMatchesTitle() }}</span>
                <p class="empty-state-subtext" [innerHTML]="LL.helpPage.messages.noMatchesSubtext()"></p>
              </div>
            </div>
          }
        </cs-card-content>
      </cs-card>
    }

    <!-- FAQ Sections List (shown when not searching and no section selected) -->
    @if (searchText.length === 0 && !showSpinner && faqSections.length > 0 && !selectedFaqSection) {
      <cs-card>
        <cs-card-content class="faq-content">
          <h3 class="faq-title">{{ LL.helpPage.faq.title() }}</h3>
          <div class="faq-items">
            @for (section of faqSections; track section) {
              <div class="faq-item" tappable (click)="handleFaqSectionClick(section)">
                <span class="faq-item-title">{{ section.summary }}</span>
                <cs-icon name="arrow-dropright"></cs-icon>
              </div>
            }
          </div>
        </cs-card-content>
      </cs-card>
    }

    <!-- Selected FAQ Section Details -->
    @if (searchText.length === 0 && !showSpinner && selectedFaqSection) {
      <cs-card>
        <cs-card-content class="faq-details-content">
          <div class="faq-details-header" tappable (click)="handleBackToFaqList()">
            <cs-icon name="arrow-dropleft"></cs-icon>
            <h3 class="faq-details-title">{{ selectedFaqSection.summary }}</h3>
          </div>
          <cs-markdown [textMarkdown]="selectedFaqSection.details"></cs-markdown>
        </cs-card-content>
      </cs-card>
    }

    <!-- Support Card -->
    <cs-support-card></cs-support-card>
  </cs-card-list>
</cs-content>
